<template>
  <div
    class="
      flex
      justify-between
      items-center
      card-container
      mx-auto
      text-main-text
    "
    :class="{ 'overflow-hidden': desktop_menu }"
  >
    <div class="flex items-center">
      <!-- logo -->
      <div class="mr-2">
        <router-link
          v-if="theme == 'white'"
          class="w-32 lg:w-40 xl:w-40 z-10 cursor-pointer"
          to="/"
          ><img
            src="@/assets/SVG/logo_white.svg"
            @click="$router.push('/')"
            alt
        /></router-link>
        <router-link
          v-else
          class="w-32 lg:w-40 xl:w-40 z-10 cursor-pointer"
          to="/"
          ><img
            src="@/assets/SVG/logo_black.svg"
            @click="$router.push('/')"
            alt
        /></router-link>
      </div>

      <!-- show city -->
      <StubCity class="hidden lg:inline-block" :theme="theme"></StubCity>
    </div>

    <!-- burger menu & user profile &city for mobile  -->
    <div class="flex justify-end flex-col relative lg:hidden">
      <div class="flex">
        <UserModal
          @logout="$emit('logout')"
          @registration_open="$emit('auth')"
          isPhone="isPhone"
          :borderColor="borderColor"
        ></UserModal>

        <!-- burger menu -->

        <img
          v-if="theme == 'white'"
          class="w-4 sm:w-6 ml-auto"
          src="@/assets/SVG/burger_white.svg"
          alt=""
          @click.prevent="close(true)"
        />
        <img
          v-else
          class="w-4 sm:w-6 ml-auto"
          src="@/assets/SVG/burger-dark.svg"
          alt=""
          @click.prevent="close(true)"
        />
      </div>

      <StubCity
        :theme="theme"
        class="absolute mt-8"
        style="top: 20px; right: 0"
      ></StubCity>
    </div>

    <div class="items-center hidden lg:inline-block">
      <div>
        <nav class="-mx-2 lex items-center inline-flex text-sm">
          <a
            href="https://party.mozgo.com/"
            class="
              mx-2
              hover:opacity-75
              opacity-100
              font-bold
              no-underline
              outline-none
            "
            :class="[
              `text-${theme}`,
              theme != ' white' ? `hover:text-white` : '',
            ]"
            v-if="!hideMozgoParty"
            >MozgoParty</a
          >

          <a href="https://partners.mozgo.com/?utm_source=mozgocom">
            <button
              class="
                mx-2
                hover:opacity-75
                opacity-100
                font-bold
                outline-none
                text-sm
              "
              :class="[
                `text-${theme}`,
                theme != ' white' ? `hover:text-white` : '',
              ]"
            >
              Купить франшизу
            </button></a
          >

          <a
            href="https://corp.mozgo.com?utm_source=mozgo"
            class="
              mx-2
              hover:opacity-75
              opacity-100
              font-bold
              outline-none
              no-underline
            "
            :class="[
              `text-${theme}`,
              theme != ' white' ? `hover:text-white` : '',
            ]"
            >Заказать корпоратив</a
          >
          
          <UserModal
            @logout="$emit('logout')"
            @registration_open="$emit('auth')"
            :borderColor="borderColor"
          ></UserModal>
        </nav>
      </div>
    </div>
    <desktop-menu
      v-if="desktop_menu"
      @close="close(false)"
      @logout="$emit('logout')"
      @registration_open="$emit('auth')"
      class="lg:hidden"
    ></desktop-menu>
  </div>
</template>


<script>
import UserModal from '../../../helpers/user-modal';
import SelectCity from '../../stub/stub_city_select';
import StubCity from '../../stub/stub_city';
import DesktopMenu from './desktop-menu';

export default {
  name: 'header-dark',
  components: {
    DesktopMenu,
    SelectCity,
    UserModal,
    StubCity,
  },
  data() {
    return {
      showCity: false,
      desktop_menu: false,
    };
  },
  props: {
    theme: {
      type: String,
      default: 'dark',
    },
    hideMozgoParty: {
      type: Boolean,
      default: false,
    },
    hideMozgoLive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    borderColor() {
      if (this.theme == 'white') {
        return 'border-white';
      }
      return 'border-black';
    },
  },
  methods: {
    close(value) {
      this.desktop_menu = value;
      if (value) {
        document.getElementById('app').style.position = 'fixed';
      } else {
        document.getElementById('app').style.position = '';
      }
    },
  },
};
</script>

<style scoped>
.round {
  border-radius: 20px;
  border-width: 1px;
  width: 1.7em;
  height: 1.7em;
}
.fw-down {
  left: 50%;
  bottom: 5%;
}
a {
  transition: all 0.5s;
}
.card-container {
  width: 80%;
}
@media (max-width: 768px) {
  .card-container {
    width: 90%;
  }
}
</style>
